module.exports = __webpack_public_path__ + "img/bjp-restricciones-cobro-2026.857e8530.png";